module.exports = __webpack_public_path__ + "img/r-logo.31f31545.svg";